import React from 'react';
import Strings from "../Lang/strings";
import SelectSearch,{fuzzySearch} from 'react-select-search';

import 'react-select-search/style.css';
import '../assets/css/customSelect.css';



const Select = ({options, value = null, name, title, changeHandler, disabled = false}) => {
    return (
        <>
            <label className={"block capitalize mb-0"} htmlFor={name}>
                {Strings.getString(title)}
            </label>
            <div className="relative">
                <SelectSearch
                    options={options}
                    disabled={disabled}
                    value={value}
                    filterOptions={fuzzySearch}
                    search
                    onChange={changeHandler}
                    placeholder={
                        Strings.formatString(Strings.select, {
                            keyword: Strings.getString(title)
                        })
                    }/>
            </div>
        </>
    );
};

export default Select;
